import React,{memo} from "react";
 
function NoMacthing(){
    return(
        <div className="">
            <h1 className="p-5 bg-indigo-500 text-3xl grow h-screen">No Macthing results found</h1>
        </div>
    );
}
export default memo(NoMacthing);